import * as R from 'ramda'

import toPx from './toPx'

const translate = R.curry((fn, { x, y }) => `translate(${fn(x)}, ${fn(y)})`)
export const translateToCssString = translate(toPx)
export const translateToSvgString = translate(R.identity)
